export default __webpack_public_path__ + "static/media/none.3a4e26b5.png";